module.exports = require("core-js/modules/es.number.is-integer.js");